export const OneUnconditionalFreeReplacement = () => {
  return (
    <div className='personalContent mx-auto mb-[40px] flex flex-col bg-[#f8f8f8] lg_mb-[80px] lg_h-[400px] lg_flex-row lg_px-0 '>
      <div
        className='bg-cover mb-[20px] aspect-[375/200] lg_mb-0 lg_aspect-auto lg_h-full lg_basis-1/2'
        style={{
          backgroundImage: 'url(/warranty-page/one-unconditional-free-replacement.webp?v=1.0.0)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      ></div>
      <div className='flex flex-col items-start justify-start px-[12px] lg_basis-1/2 lg_px-[40px] lg_pt-[40px]'>
        <h1
          className='mb-[10px] font-teko-medium text-[28px] uppercase leading-[30px] lg_mb-[20px] lg_text-[40px] lg_leading-[40px] '
          style={{ wordBreak: 'break-all' }}
          id='one-unconditional-free-replacement'
        >
          <span className='uppercase text-secondary'>ONE</span> Unconditional{' '}
          <span className='uppercase text-secondary'>Free</span> Replacement
        </h1>

        <p className='mb-[20px] font-roboto-light text-[16px] font-light leading-[26px]'>
          At HISEA, we want you to feel confident in your purchase. In addition to our Lifetime Warranty, we also offer
          <span className='font-bold'>ONE Unconditional Free Replacement</span>. This means that even if an issue falls
          outside the warranty coverage, you can still receive a replacement at no cost.
        </p>
        <p className='mb-[10px] font-roboto-light text-[16px] font-light leading-[26px] lg_mb-[20px]'>
          This reflects our dedication to exceptional service and our commitment to helping ensure your satisfaction.
        </p>
        {/* <p className='mb-[20px] font-roboto-light text-[16px] font-light leading-[26px]'>
          Besides, coverage will end if you refund, sell, or transfer the product to another party.
        </p> */}
      </div>

      {/* <Image
        src={'/warranty-page/one-unconditional-free-replacement.webp?v=1.0.0'}
        alt='one unconditional free replacement'
        width={550}
        height={400}
        quality={100}
        className='mt-[15px] h-full w-full basis-1/2 object-contain lg_mt-0'
      /> */}
    </div>
  );
};
